import { z } from 'zod';
export const subscriptionStateSchema = z.enum(['NONE', 'ACTIVE', 'ERROR', 'PENDING']);
export const targetDtoSchema = z.object({
    id: z.string(),
    xUserId: z.string(),
    handle: z.string(),
    displayName: z.string(),
    avatarUrl: z.string().nullable(),
    description: z.string().nullable(),
    followersCount: z.number().int(),
    followingCount: z.number().int(),
    verified: z.boolean(),
    isProtected: z.boolean(),
    isActive: z.boolean(),
    color: z.string().nullable(),
    notes: z.string().nullable(),
    subscriptionState: subscriptionStateSchema,
    subscriptionError: z.string().nullable(),
    lastPostAt: z.string().nullable(),
    postCount: z.number().int(),
    createdAt: z.string(),
});
const HANDLE_RE = /^[A-Za-z0-9_]{1,15}$/;
/** Accepts `@name`, `name`, or an x.com/twitter.com profile URL. */
export const handleInputSchema = z
    .string()
    .trim()
    .min(1)
    .transform((raw) => {
    const fromUrl = raw.match(/(?:x\.com|twitter\.com)\/(?:#!\/)?@?([A-Za-z0-9_]{1,15})/i);
    return (fromUrl?.[1] ?? raw).replace(/^@/, '').trim();
})
    .refine((handle) => HANDLE_RE.test(handle), {
    message: 'Not a valid X handle (1-15 letters, digits or underscores).',
});
export const createTargetRequestSchema = z.object({
    handle: handleInputSchema,
    color: z
        .string()
        .regex(/^#[0-9a-fA-F]{6}$/)
        .nullish(),
    notes: z.string().max(2000).nullish(),
});
export const updateTargetRequestSchema = z.object({
    isActive: z.boolean().optional(),
    color: z
        .string()
        .regex(/^#[0-9a-fA-F]{6}$/)
        .nullish(),
    notes: z.string().max(2000).nullish(),
});
//# sourceMappingURL=target.js.map